<Dialog bind:value={showDialog} class="w-full md:w-3/4 max-h-3/4 overflow-y-auto" {transitionProps}>
    <div slot="title" class="text-lg font-normal">Kategooriate muutmine</div>
    <div class="xs:overflow-x-scroll">
        <table class="cash-entry-category-table">
            <tr class="p-10">
                <th class="w-0.5">Nr</th>
                <th>Nimetus</th>
                <th class="w-1"></th>
            </tr>
            {#each cashEntryCategories as category, i}
                <tr>
                    <td>{ i + 1 }</td>
                    <td>
                        <input type="text" placeholder="Nimetus" class="border rounded p-2 w-full" bind:value={category.title}>
                    </td>
                    <td>
                        <Button color="error" small class="flex align-middle px-1" remove="px-4 pl-2 pr-2"
                                on:click={deleteCashEntryCategory(category)}>
                            <Icon small>delete</Icon>
                        </Button>
                    </td>
                </tr>
            {/each}
        </table>
    </div>
    <div class="flex justify-start mt-1">
        <Button on:click={addNewCashEntryCategory} text color="secondary" class="flex align-middle">
            <Icon>add</Icon>
            <span class="self-center">Lisa uus kategooria</span>
        </Button>
    </div>
    <div slot="actions">
        <Button color="secondary" on:click={() => showDialog = false}>Tühista</Button>
        <Button on:click={saveCashEntryCategories}>Salvesta</Button>
    </div>

</Dialog>


<script lang="ts">
    import {Dialog, Button, Icon} from 'smelte';
    import {quadIn} from 'svelte/easing';
    import {onMount} from 'svelte';
    import ApiService from '../api-service';
    import {snackbar, userInfo} from '../stores';

    export let showDialog: boolean = false;

    const transitionProps = {duration: 150, easing: quadIn, delay: 0};

    let cashEntryCategories: any[] = [];

    onMount(async () => {
        const response = await ApiService.getCashEntryCategoriesForUser($userInfo.id);
        cashEntryCategories = response.data;
    });

    function addNewCashEntryCategory() {
      let cashEntryCategory = {
        title: undefined
      };
      cashEntryCategories = [...cashEntryCategories, cashEntryCategory];
    }

    async function saveCashEntryCategories() {
      cashEntryCategories = cashEntryCategories.filter(category => category.title !== null && category.title !== undefined && category.title !== '');
      await ApiService.createOrUpdateCashEntryCategoriesBatch(cashEntryCategories);
      showDialog = false;
      snackbar.show('Kategooriad salvestatud');
    }

    async function deleteCashEntryCategory(category) {
      await ApiService.deleteCashEntryCategory(category.id);
      cashEntryCategories = cashEntryCategories.filter(c => c.id !== category.id);
    }
</script>

<style>
    .cash-entry-category-table {
        @apply w-full shadow rounded border-separate;
        border-spacing: 0;
    }

    .cash-entry-category-table tr th,
    .cash-entry-category-table tr td {
        @apply border-r border-b text-sm;
    }

    .cash-entry-category-table tr th:first-child,
    .cash-entry-category-table tr td:first-child {
        @apply border-l;
    }

    .cash-entry-category-table tr th {
        @apply border-t font-medium text-left p-3;
    }

    .cash-entry-category-table tr td {
        @apply p-3;
    }

    .cash-entry-category-table tr:first-child th:first-child {
        @apply rounded-tl;
    }

    .cash-entry-category-table tr:first-child th:last-child {
        @apply rounded-tr;
    }

    .cash-entry-category-table tr:last-child td:first-child {
        @apply rounded-bl;
    }

    .cash-entry-category-table tr:last-child td:last-child {
        @apply rounded-br;
    }
</style>